import { render, staticRenderFns } from "./BoxBG.vue?vue&type=template&id=46659dcc&scoped=true&"
import script from "./BoxBG.vue?vue&type=script&lang=js&"
export * from "./BoxBG.vue?vue&type=script&lang=js&"
import style0 from "./BoxBG.vue?vue&type=style&index=0&id=46659dcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46659dcc",
  null
  
)

export default component.exports